import React from 'react';
import {
  FolderAddOutlined,
  CloudDownloadOutlined,
  CloudUploadOutlined,
  FolderFilled,
  DeleteOutlined,
  EditOutlined,
  FileUnknownOutlined,
  PlusOutlined,
  FileImageOutlined,
  PlayCircleOutlined,
  FileZipOutlined,
  ReadOutlined,
  SendOutlined,
  WarningOutlined,
  ExportOutlined,
  FormOutlined,
  CopyOutlined,
  TrademarkOutlined,
  UndoOutlined,
  RightOutlined,
  LeftOutlined,
  ReloadOutlined,
  LoginOutlined,
  QuestionCircleOutlined,
  UploadOutlined,
  SortAscendingOutlined,
  SortDescendingOutlined,
  EyeOutlined,
  EyeInvisibleOutlined,
  LogoutOutlined,

  StarOutlined,
  CheckOutlined,
  UnorderedListOutlined,
} from '@ant-design/icons';

export default {
  fileDownload: <CloudDownloadOutlined />,
  fileUpload: <CloudUploadOutlined />,
  folderUpload: <UploadOutlined />,
  createNewFolder: <FolderAddOutlined />,
  delete: <DeleteOutlined />,
  rename: <EditOutlined />,
  folder: <FolderFilled />,
  volumeUp: <PlusOutlined />,
  image: <FileImageOutlined />,
  ondemandVideo: <PlayCircleOutlined />,
  archive: <FileZipOutlined />,
  book: <ReadOutlined />,
  insertDriveFile: <FileUnknownOutlined />,
  moveTo: <ExportOutlined />,
  editDescription: <FormOutlined />,
  warning: <WarningOutlined />,
  send: <SendOutlined />,
  copy: <CopyOutlined />,
  setRootFolder: <TrademarkOutlined />,
  resetRootFolder: <UndoOutlined />,
  nextArrow: <RightOutlined style={{ fontSize: '12px' }} />,
  moveBackward: <LeftOutlined />,
  moveForward: <RightOutlined />,
  refresh: <ReloadOutlined />,
  login: <LoginOutlined />,
  logout: <LogoutOutlined />,
  question: <QuestionCircleOutlined />,
  asc: <SortAscendingOutlined />,
  desc: <SortDescendingOutlined />,
  visible: <EyeOutlined />,
  invisible: <EyeInvisibleOutlined />,

  star: <StarOutlined />, //create service request
  check: <CheckOutlined />, //create Note
  unorderedList: <UnorderedListOutlined />, //create task
};
